import React from 'react';
import { BoxNotification } from 'components/containers/BoxNotification';
import { CenteredContentLayout } from 'components/containers/CenteredContentLayout';
import classes from './BlockedAccess.module.scss';

export const BlockedAccess = () => {
  return (
    <CenteredContentLayout>
      <div className={classes.Container}>
        <BoxNotification type="error">This Organization has been suspended.</BoxNotification>
      </div>
    </CenteredContentLayout>
  );
};
